import type { RecipeIndexEntry } from '../../services/unifiedRecipeService';
import { isBreakfastRecipe, isNonMealRecipe } from '../../utils/recipeClassification';
import { hasIngredients } from '../../utils/recipeContent';

/**
 * Can this recipe be served in this slot's meal type? (#528 — the generator used
 * to pick at random from the whole library, so a pasta dinner landed on a Sunday
 * morning.) Same rule as the Remplacer fan (fanSuggestionsService): a breakfast
 * slot takes breakfast recipes only, a dîner/souper slot takes real meals only —
 * which already excludes breakfast dishes, desserts, drinks, snacks and condiments.
 * A recipe with no ingredient fits no slot: there is nothing to cook or to buy.
 */
export function fitsMealType(recipe: RecipeIndexEntry, mealIndex: number): boolean {
  if (!hasIngredients(recipe)) return false;
  return mealIndex === 0 ? isBreakfastRecipe(recipe) : !isNonMealRecipe(recipe);
}
